class AppConfig {
    static ApiBaseUrl = 'https://pdpmapi.techbitsolution.com';
}

export default AppConfig;
